import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { darkColors, primaryColors } from '@tryhackme/thm-ui-components';
import styled, { css } from 'styled-components';

export const ColoredSpan = styled.span<{ $isDarkMode: boolean }>`
  color: ${({ theme, $isDarkMode }) => ($isDarkMode ? primaryColors.main : theme.colors.success.main)};
`;

export const StyledTable = styled.table<{ $isMobile: boolean; $isDarkMode: boolean }>`
  position: relative;
  border-spacing: 0px;
  width: 100%;
  max-width: 80rem;

  color: ${({ theme }) => theme.colors.text.main};
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  font-weight: ${({ theme }) => theme.fonts.weight.regular};
  font-size: ${({ theme }) => theme.fonts.sizes.medium};
  word-break: break-word;

  thead tr th {
    font-weight: ${({ theme }) => theme.fonts.weight.bolder};
    font-size: 2.4rem;
    line-height: 2.8rem;
    padding: 2.4rem 0rem;
  }

  tbody tr {
    td {
      border-bottom: 1px solid
        ${({ theme, $isDarkMode }) => ($isDarkMode ? theme.colors.secondary.lighter : theme.colors.grey[300])};
    }
    &:last-child {
      td {
        border-bottom: none;
      }
    }
  }

  tbody tr td {
    &:nth-child(1) {
      padding: 1.6rem;
    }
    &:nth-child(2),
    &:nth-child(3) {
      width: 15rem;
      padding: 2.2rem 0rem;
      line-height: 16px;
    }
  }

  &::before {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    width: 15rem;
    height: calc(100% - 6.8rem);
    background: linear-gradient(180deg, ${darkColors.info.soft} 0%, transparent 100%);
    z-index: -1;
    border-radius: 2rem 2rem 0 0;
  }

  ${({ $isMobile }) =>
    $isMobile &&
    css`
      font-size: ${({ theme }) => theme.fonts.sizes.default};

      thead tr th {
        font-size: ${({ theme }) => theme.fonts.sizes.medium};
      }

      tbody tr td {
        &:nth-child(1) {
          padding: 1rem;
        }

        &:nth-child(2),
        &:nth-child(3) {
          padding: 2.1rem 0rem;
          width: 9.5rem;
        }
      }

      &::before {
        width: 9.5rem;
      }
    `}
`;

export const CheckIcon = styled(FontAwesomeIcon)`
  size: ${({ theme }) => theme.fonts.sizes.default};
  color: ${({ theme }) => theme.colors.text.button};
`;

export const XIcon = styled(FontAwesomeIcon)`
  font-size: ${({ theme }) => theme.fonts.sizes.medium};
  color: ${({ theme }) => theme.colors.grey[600]};
`;

export const StyledDetailBlock = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 0.8rem;
  text-align: center;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 1.6rem 1rem;
  button {
    width: 100%;
  }
`;

export const StyledImg = styled.img`
  position: absolute;
  top: 0;
  right: 0;
  width: 7.7rem;
  transform: translate(17px, -31px) rotate(20deg);
`;
